import { POINT_TYPES } from '../../../../../shared/utils/tree';
import Well from './Well';

const GroundwaterSource = ({ data, type }) => {
  return type === POINT_TYPES.WELL ? <Well data={data} /> : <></>;
};

export default GroundwaterSource;
